module.exports = __webpack_public_path__ + "static/media/unavailable-building.7255a9f6.svg";